import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NavController, NavParams, LoadingController, ModalController } from 'ionic-angular';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as FileSaver from 'file-saver';
import { ProfileService } from '../../../../../../UI/src/app/shared/profile/profile.service';
import { ValidationService } from '../../../../../../UI/src/app/shared/validation/validation.service';
import { ToastControllerService } from '../../../../providers/toast-controller.service';
import { FileUploadDialogComponent } from './file-upload/file-upload-dialog.component';
import { GDPRAlertDialogComponent } from './gdpr-alert/gdpr-alert-dialog.component';
import { Toast508Service } from '../../../../providers/toast-508.service';
import { AuthenticationService } from '../../../../../../UI/src/app/shared/authentication/authentication.service';
import { HomeComponent } from '../../home/home.component';
import * as moment from 'moment/moment';
import { Storage } from '../../../../../../UI/src/app/shared/constants';
import * as _ from 'lodash';

@Component({
  selector: 'page-edit-profile',
  templateUrl: 'profile.component.html'
})
export class ProfileEditComponent implements OnInit {
  profileData: CandidateProfileDTO;
  preferences: CandidatePreferenceDTO;
  selectedCountry: any;
  states: any;
  alertData: any = null;
  showAlert = false;
  translations: any;
  public dateFormat: any;
  candidateAttachments = [];
  contactCollapsedHeader = true;
  candidateAttachmentCount = 0;
  showLoader = false;
  mobilePhoneNumber;
  homePhoneNumber;
  user: any = {};
  fields: any;
  public userEditForm: FormGroup;
  isValidHomePhoneNumber = true;
  isValidMobilePhoneNumber = true;
  passwordMatch = false;
  todayDate = new Date().toISOString();
  public countryFieldKey = 'PersonCommunication_1.Country';
  public stateFieldKey = 'PersonCommunication_1.StateName';
  public zipFieldKey = 'PersonCommunication_1.Zip';
  zipcodeInputId = '';
  postalCodesLookup = [];
  hasZipField = false;

  public loading;
  constructor(
    private navCtrl: NavController,
    private navParams: NavParams,
    private loadingCtrl: LoadingController,
    private profileService: ProfileService,
    private translate: TranslateService,
    private toastService: ToastControllerService,
    public modalCtrl: ModalController,
    private toast508Service: Toast508Service,
    private authenticationService: AuthenticationService,
    private cdRef: ChangeDetectorRef,
    private formBuilder: FormBuilder
  ) {
    var culture = window.localStorage.getItem(Storage.CULTURE);
    this.dateFormat = moment.localeData(culture).longDateFormat('L');
    this.translate.get(['CAREER_PROFILE_SAVED', 'CAREER_FAILED_MESSAGE']).subscribe((obj) => {
      this.translations = obj;
    });
    this.loading = this.loadingCtrl.create({
      duration: 15000
    });
    this.profileData = new CandidateProfileDTO();
    this.preferences = new CandidatePreferenceDTO();
    this.getCandidateProfile();
  }

  ngOnInit() {
    this.getEditCandidateForm();
  }

  private getEditCandidateForm() {
    this.loading.present();
    this.profileService.getCandidateEditFormConfiguration().subscribe(
      (response) => {
        let formObject = {
          fields: [],
          user: {}
        };
        formObject = this.authenticationService.constructFieldAttributes(response.fields, this.user);
        this.fields = formObject.fields;
        this.user = formObject.user;

        this.constructUserEditForm();

      },
      (error) => {
        this.loading.dismiss();
      }
    );
  }

  private constructUserEditForm() {
    let validatorObject = {};
    validatorObject = this.authenticationService.constructUserForm(this.fields, 'editAccount');
    this.userEditForm = this.formBuilder.group(validatorObject);
    this.hasZipField = _.findIndex(this.fields, (item) => { return item.fieldName === this.zipFieldKey }) !== -1
    this.loadPostalCodes();
    this.loading.dismiss();
    this.cdRef.detectChanges();
  }

  checkPasswordMatch() {
    if (
      this.user['UserLogin.UserPassword'] !== undefined &&
      this.user['UserLogin.UserPassword'] !== '' &&
      this.user['UserLogin.ConfirmUserPassword'] !== '' &&
      this.user['UserLogin.ConfirmUserPassword'] !== undefined
    ) {
      if (this.user['UserLogin.ConfirmUserPassword'] === this.user['UserLogin.UserPassword']) {
        this.passwordMatch = false;
        return false;
      } else if (this.user['UserLogin.ConfirmUserPassword'] !== this.user['UserLogin.UserPassword']) {
        this.passwordMatch = true;
        return true;
      }
    }
  }

  getCandidateProfile() {
    this.loading.present();
    this.profileService.getCandidateProfileData().subscribe(
      (response) => {
        this.loading.dismiss();
        this.profileData = response;
        this.candidateAttachments = response.attachments;
        this.mobilePhoneNumber = this.profileData.mobilePhoneNumber;
        this.homePhoneNumber = this.profileData.homePhoneNumber;
        if (response.preferences) {
          this.preferences = response.preferences;
        }
        this.updateCandidateAttachmentCount();
        if (this.profileData.firstName === '-') {
          this.profileData.firstName = '';
        }
        if (this.profileData.lastName === '-') {
          this.profileData.lastName = '';
        }
        this.fillSelectedCountry(this.profileData.country);
        this.user[this.zipFieldKey] = this.profileData.postalCode;
      },
      (error) => {
        this.loading.dismiss();
      }
    );
  }

  saveProfileData() {
    this.loading.present();
    const jsonRequest = this.authenticationService.constructUserObject(this.user);
    this.profileService.saveCandidateProfile(jsonRequest, this.candidateAttachments, this.preferences).subscribe(
      (response) => {
        this.loading.dismiss();
        this.getCandidateProfile();
        if (response.responseStatus) {
          this.alertData = {
            message: this.translations.CAREER_PROFILE_SAVED,
            type: 'success'
          };
        } else if (response.response.error_code === '-2') {
          this.alertData = {
            message: response.response.error_message,
            type: 'error'
          };
        } else if (response.response.error_code === '-1' || response.response.error_code === '0') {
          this.alertData = {
            message: response.response.error_message,
            type: 'error'
          };
        }
        this.toastService.presentToast(this.alertData);
        this.toast508Service.toFocus();
      },
      (error) => {
        this.loading.dismiss();
        this.alertData = {
          message: this.translations.CAREER_FAILED_MESSAGE,
          type: 'error'
        };
        this.toastService.presentToast(this.alertData);
        this.toast508Service.toFocus();
      }
    );
  }

  openFileUpload() {
    let uploadModal = this.modalCtrl.create(FileUploadDialogComponent);
    uploadModal.onDidDismiss((result) => {
      if (result) {
        this.candidateAttachments.push(result);
        this.updateCandidateAttachmentCount();
      }
    });
    uploadModal.present();
  }

  deleteAttachment(attachment) {
    const selectedIndex = this.candidateAttachments.findIndex((doc) => doc.fileAssetFK === attachment.fileAssetFK);
    this.candidateAttachments[selectedIndex].deleted = true;
    this.updateCandidateAttachmentCount();
  }

  downLoadAttachment(attachment) {
    this.profileService.downloadFile(attachment.fileAssetFK).subscribe((res) => {
      FileSaver.saveAs(res, attachment.originalName);
    });
  }

  updateCandidateAttachmentCount() {
    this.candidateAttachmentCount = this.candidateAttachments.filter(
      (attachment) => attachment.deleted === false
    ).length;
  }

  getPersonJson() {
    return {
      Person: {
        PersonPK: this.profileData.personPK,
        FirstName: this.profileData.firstName,
        MiddleName: this.profileData.middleName,
        LastName: this.profileData.lastName,
        GenderCode: this.profileData.genderCode,
        CurrencyFK: this.profileData.currencyFK,
        TimeZoneFK: this.profileData.timeZoneFK,
        LocaleFK: this.profileData.localeFK,
        BirthDate: this.profileData.birthDate,
        PersonNumber: this.profileData.personNumber,
        PersonTM: {
          MaritalCode: this.profileData.maritalCode,
          DistanceUnitCode: this.profileData.distanceUnitCode,
          NumberFormatCode: this.profileData.numberFormatCode
        },
        UserLogin: {
          UserPassword: this.profileData.password
        },
        PersonRelation: {
          JobTitle: this.profileData.jobTitle
        },
        PersonCommunication: [
          {
            Email1: this.profileData.email,
            CommunicationType: 1,
            Mobile: this.profileData.mobilePhoneNumber,
            Phone: this.profileData.homePhoneNumber,
            Address1: this.profileData.address,
            Address2: this.profileData.address2,
            City: this.profileData.city,
            StateName: this.profileData.state,
            Country: this.profileData.country,
            Zip: this.profileData.postalCode
          }
        ]
      }
    };
  }

  getHomePhoneNumber(homeNumber) {
    this.profileData.homePhoneNumber = homeNumber;
    this.isValidHomePhoneNumber = true;
    if (homeNumber === null) {
      this.isValidHomePhoneNumber = false;
    } else if (homeNumber === true) {
      this.isValidHomePhoneNumber = true;
      this.profileData.homePhoneNumber = '';
    }
  }

  getMobilePhoneNumber(mobileNumber) {
    if (typeof (mobileNumber) !== 'boolean') {
      this.user['PersonCommunication_1.Mobile'] = mobileNumber;
      if (this.userEditForm.controls['user.PersonCommunication_1.Mobile'] && mobileNumber) {
        this.userEditForm.controls['user.PersonCommunication_1.Mobile'].setValue({ valid: true });
      } else {
        if (_.find(this.fields, (item) => { return item.fieldName === 'PersonCommunication_1.Mobile' }).attribute.required) {
          this.userEditForm.controls['user.PersonCommunication_1.Mobile'].setValue({ valid: false });
        } else {
          this.userEditForm.controls['user.PersonCommunication_1.Mobile'].setValue({ valid: true });
        }
      }
    }
    this.isValidMobilePhoneNumber = true;
    if (mobileNumber === null) {
      this.isValidMobilePhoneNumber = false;
    } else if (mobileNumber === true) {
      this.isValidMobilePhoneNumber = true;
      this.profileData.mobilePhoneNumber = '';
    }
  }

  fillSelectedCountry(selectedCountry) {


    if (this.profileData.country) {
      const selCountry = this.profileData.countries.filter(function (element, index, array) {
        if (element.countryName === selectedCountry || element.countryCd === selectedCountry) {
          return element;
        }
      });
      if (selCountry && selCountry.length > 0) {
        this.selectedCountry = selCountry[0];
        this.getStatesByCountry();
      }

    }

  }

  getStatesByCountry() {
    this.states = [];
    this.profileData.country = this.selectedCountry.countryName;
    this.user[this.countryFieldKey] = this.selectedCountry.countryCd;

    if (this.selectedCountry.hasProvince) {
      this.loading.present();
      this.profileService.getStatesByCountry(this.selectedCountry.countryCd).subscribe(
        (response) => {
          this.loading.dismiss();
          this.states = response || [];
          const selectedState = this.profileData.state;
          if (selectedState) {
            if (this.states && this.states.length > 0) {
              const selState = this.states.filter(function (element, index, array) {
                if (element.provinceName === selectedState || element.provinceCd === selectedState) {
                  return element;
                }
              });
              if (selState && selState.length > 0) {
                this.user[this.stateFieldKey] = selState[0].provinceCd;
              }
            }
          }
        },
        (error) => {
          this.loading.dismiss();
        }
      );
    } else {
      this.profileData.state = '';
    }
  }

  validateControls(): boolean {
    if (
      this.profileData.firstName === '' ||
      this.profileData.lastName === '' ||
      +this.profileData.timeZoneFK === 0 ||
      +this.profileData.localeFK === 0
    ) {
      return false;
    } else if (!this.isNullOrEmpty(this.profileData.password)) {
      if (!this.isValidPassword()) {
        return false;
      }
      if (this.profileData.password !== this.profileData.confirmPassword) {
        return false;
      }
    } else if (!this.isNullOrEmpty(this.profileData.confirmPassword)) {
      if (this.profileData.password !== this.profileData.confirmPassword) {
        return false;
      }
    } else if (!this.isNullOrEmpty(this.profileData.email)) {
      if (!ValidationService.isValidEmail(this.profileData.email)) {
        return false;
      }
    }
    return true;
  }

  isValidPassword() {
    if (!this.isNullOrEmpty(this.profileData.password)) {
      if (!ValidationService.isValidPassword(this.profileData.password)) {
        return false;
      }
    }
    return true;
  }

  isNullOrEmpty(value): Boolean {
    if (value !== null && value !== undefined && value !== '') {
      return false;
    }
    return true;
  }

  // Downloads personal data in CSV format
  downloadPersonalData() {
    this.profileService.downloadPersonalData().subscribe((res) => {
      FileSaver.saveAs(res, 'PersonalData.csv');
    });
  }

  ondeleteAccount() {
    let deleteAccountModalRef = this.modalCtrl.create(GDPRAlertDialogComponent);
    deleteAccountModalRef.present();
    deleteAccountModalRef.onDidDismiss((result) => {
      //Only if delete account service call got success move to home page.
      if (result) {
        this.navCtrl.setRoot(HomeComponent);
      }
      deleteAccountModalRef.dismiss();
    });
  }
  loadPostalCodes() {
    this.zipcodeInputId = 'zipcode';
    if (this.hasZipField && this.user[this.stateFieldKey]) {
      this.authenticationService.getPostalCodesByCountryState(this.user[this.countryFieldKey], this.user[this.stateFieldKey])
        .subscribe((response) => {
          this.postalCodesLookup = _.uniq((response || []).map(r => _.capitalize(r.postalCd)));
        });
    }
  }
  selectedZipcode(zipcode: any) {
    this.user['PersonCommunication_1.Zip'] = zipcode;
  }

  onfocusout(event: any) {

  }

}
export class CandidateProfileDTO {
  personPK: number;
  personNumber: string;
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  homePhoneNumber: string;
  mobilePhoneNumber: string;
  address: string;
  address2: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
  birthDate: Date;
  gender: string;
  maritalStatus: string;
  userName: string;
  password: string;
  confirmPassword: string;
  jobTitle: string;
  genderCode: string;
  currencyFK: number;
  timeZoneFK: number;
  localeFK: number;
  maritalCode: string;
  distanceUnitCode: number;
  numberFormatCode: number;
  countries: any;
  genderCodes: any;
  locales: any;
  timeZones: any;
  numberFormats: any;
  currencyCodes: any;
  distanceUnits: any;
  maritalCodes: any;
}

export class CandidatePreferenceDTO {
  id: number;
  personFK: number;
  notificationByEmail: boolean;
  notificationByMobile: boolean;
  internalNotification: boolean;
}



// WEBPACK FOOTER //
// ./src/app/modules/edit-profile/profile/profile.component.ts